import { storyblokInit } from 'gatsby-source-storyblok';
import configuration from '../../../gatsby-config';
import {
  BlockGroup,
  BlogGridTiles,
  CardsSection,
  ChecklistBox,
  CompanyFacts,
  ContactForm,
  ContactFormComponent,
  FullWidthSlider,
  FullWidthSliderContent,
  Headlines,
  Hero,
  HistorySection,
  ImagesSlideshow,
  JobPositions,
  JobRow,
  JobTags,
  LaunchplanForm,
  LinkList,
  MapsSection,
  MeetTeammember,
  PartnerLogos,
  PartnerFAQSection,
  PartnerReferencesSection,
  Person,
  Persons,
  Perks,
  ProvenexpertForm,
  ReferencesTiles,
  RichTextSection,
  Richtext,
  ScrollSlider,
  ScrollSliderItem,
  ServiceStepRows,
  ServiceSteps,
  ServicesTiles,
  SpacerNew,
  SpecialistForm,
  TestimonialCards,
  TestimonialCardsContent,
  TextWithImageSection,
  TextWrapper,
  UseCasesTiles,
  VerticalSlider,
  VerticalTestimonials,
  OurServices,
  BlogPostMediaVideo,
  BlogGridView,
  ImageSlider,
  CtaButton,
  Success,
  Button,
  HorizontalImageList,
  Achievements,
  ShopifyBadges,
  ShopifyCertificates,
  AchievementsSection,
  GenericCollasibleSection,
  BlogPostFAQ,
  ClientLogosSection,
  BlogpostQuickInsight,
  PartnersOverview,
  ReferenceIntroSection,
  ReferenceFactsSection,
  ReferenceFactItem,
  ReferenceChallengeSection,
  ReferenceBulletPoint,
  ReferenceSolutionSection,
  QuotationBox,
  QuotationSlider,
  ReferenceFaqSection,
  ReferenceFaqItem,
  ImageBlock,
} from './index';
import {
  ImagesSlideshowRow,
  PartnerCategory,
  ReferenceImplementation,
  SplitPanesStories,
} from './legacy-storyblok-components';

const sbConfig = configuration.plugins.find((item) => item.resolve === 'gatsby-source-storyblok');

(() => {
  storyblokInit({
    accessToken: sbConfig.options.accessToken,
    cache: {
      clear: 'auto',
      type: 'memory',
    },
    resolveRelations: [
      'blogpost.author',
      'blogpost.reviewer',
      'page.jobs',
      'job-positions.jobs',
      // 'references-tiles.tile',
      'use-cases-tiles.use_case',
      'services-tiles.services',
      'service.icon',
      'perk.icon',
      'perks.icon',
      'navigation.Menu',
      'page.Icon',
      'blog-grid-view.posts',
    ],
    components: {
      hero: Hero,
      'company-facts': CompanyFacts,
      'block-group': BlockGroup,
      'rich-text': Richtext,
      headlines: Headlines,
      'checklist-box': ChecklistBox,
      'contact-form': ContactForm,
      'contact-form-component': ContactFormComponent,
      persons: Persons,
      person: Person,
      'rich-text-section': RichTextSection,
      'image-with-text': TextWithImageSection,
      'images-slideshow': ImagesSlideshow,
      testimonials: VerticalTestimonials,
      perks: Perks,
      'job-positions': JobPositions,
      'references-tiles': ReferencesTiles,
      'use-cases-tiles': UseCasesTiles,
      'launchplan-form': LaunchplanForm,
      linklist: LinkList,
      'spacer-new': SpacerNew,
      'cards-section': CardsSection,
      history: HistorySection,
      'our-services': OurServices,
      'testimonials-section': TestimonialCards,
      'full-width-slider': FullWidthSlider,
      'partners-logos': PartnerLogos,
      'partner-faq-section': PartnerFAQSection,
      'partner-references-section': PartnerReferencesSection,
      'full-width-slider-content': FullWidthSliderContent,
      'testimonial-content': TestimonialCardsContent,
      'text-wrapper': TextWrapper,
      'services-steps-section': ServiceSteps,
      'service-steps': ServiceStepRows, // Single Service Step Colum
      'job-single-row': JobRow,
      'jobs-tags': JobTags,
      'vertical-slider': VerticalSlider,
      'services-tiles': ServicesTiles,
      'map-section': MapsSection,
      'blogpost-tiles-component': BlogGridTiles,
      'scroll-slider': ScrollSlider,
      'scroll-slider-item': ScrollSliderItem,
      'specialist-form': SpecialistForm,
      'blog-post-media-video': BlogPostMediaVideo,
      blogpost_tiles: BlogGridTiles,
      'blog-grid-view': BlogGridView,
      'image-slider': ImageSlider,
      'cta-button': CtaButton,
      'meet-teammember': MeetTeammember,
      'provenexpert-form': ProvenexpertForm,
      Success,
      button: Button,
      'horizontal-image-list': HorizontalImageList,
      'shopify-badges': ShopifyBadges,
      'Shopify Cerificates': ShopifyCertificates,
      achievement: Achievements,
      'achievements-section': AchievementsSection,
      'Generic Collapsible': GenericCollasibleSection,
      'FAQ Collapsible': BlogPostFAQ,
      'client-logos-section': ClientLogosSection,
      'blogpost-quick-insight': BlogpostQuickInsight,
      'partners-overview': PartnersOverview,
      'reference-intro-section': ReferenceIntroSection,
      'reference-facts-section': ReferenceFactsSection,
      'reference-fact-item': ReferenceFactItem,
      'reference-challenge-section': ReferenceChallengeSection,
      'reference-bullet-point': ReferenceBulletPoint,
      'reference-solution-section': ReferenceSolutionSection,
      'Reference Intro Section': ReferenceIntroSection,
      'Reference Facts Section': ReferenceFactsSection,
      'Reference Fact Item': ReferenceFactItem,
      'Reference Challenge Section': ReferenceChallengeSection,
      'Reference Bullet Point': ReferenceBulletPoint,
      'Reference Solution Section': ReferenceSolutionSection,
      'quotation-box': QuotationBox,
      'Quotation Box': QuotationBox,
      'quotation-slider': QuotationSlider,
      'Quotation Slider': QuotationSlider,
      'reference-faq-section': ReferenceFaqSection,
      'reference-faq-item': ReferenceFaqItem,
      'Reference FAQ Section': ReferenceFaqSection,
      'Reference FAQ Item': ReferenceFaqItem,
      'Hero With Text': Hero,
      'Images Slideshow Row': ImagesSlideshowRow,
      'Partner Category': PartnerCategory,
      'Reference Implementation': ReferenceImplementation,
      'Split Panes Stories': SplitPanesStories,
      Image: ImageBlock,
    },
    localAssets: false,
  });
})();
